import clsx from 'clsx'
import icTrash from '../../../assets/images/ic-trash.svg'
import { Button, Modal } from 'avo-ui'

const ModalDelete = ({ className, show, onHide, description, totalData, isLoading, onDelete }) => {
    return (
        <Modal dialogClassName={'max-w-[328px]'} contentClassName={'rounded-xl'} show={show} onHide={onHide}>
            <>
                <div className={clsx('flex flex-col space-y-4 items-center p-10 text-neutral-70', className)}>
                    <img src={icTrash} alt={'ic-trash'} className={'w-12 h-12'} />
                    <p className={'font-semibold'}>Delete</p>
                    <p className={'text-center'}>{description}</p>
                    {totalData > 1 && <p>Total Data: {totalData}</p>}
                </div>
                <div className={'flex flex-row px-6 py-3 border-t space-x-3 justify-center'}>
                    <Button type={'outline'} title={'Cancel'} onClick={onHide} />
                    <Button title={'Delete'} loading={isLoading} onClick={onDelete} />
                </div>
            </>
        </Modal>
    )
}

export default ModalDelete
